export default "__VITE_ASSET__CqWbShss__"